import type { ViewMode } from 'features/knowledgeDocumentViewer/types'

export interface DocumentPreviewGate {
  isCardPreviewDismissed: boolean
  isTablePreviewDismissed: boolean
  hasExplicitlyOpenedPreview: boolean
}

export const INITIAL_DOCUMENT_PREVIEW_GATE: DocumentPreviewGate = {
  isCardPreviewDismissed: false,
  isTablePreviewDismissed: false,
  hasExplicitlyOpenedPreview: false,
}

interface PreviewVisibilityParams {
  viewMode: ViewMode
  isPreviewOpen: boolean
  requireExplicitOpen: boolean
  gate: DocumentPreviewGate
}

export function isDocumentPreviewVisible({
  viewMode,
  isPreviewOpen,
  requireExplicitOpen,
  gate,
}: PreviewVisibilityParams): boolean {
  if (!isPreviewOpen) return false
  const dismissed =
    viewMode === 'card'
      ? gate.isCardPreviewDismissed
      : gate.isTablePreviewDismissed
  if (dismissed) return false
  return !requireExplicitOpen || gate.hasExplicitlyOpenedPreview
}

export function openDocumentPreview(): DocumentPreviewGate {
  return {
    isCardPreviewDismissed: false,
    isTablePreviewDismissed: false,
    hasExplicitlyOpenedPreview: true,
  }
}

export function closeDocumentPreview(
  gate: DocumentPreviewGate,
  viewMode: ViewMode,
  requireExplicitOpen: boolean
): DocumentPreviewGate {
  return {
    ...gate,
    ...(viewMode === 'card'
      ? { isCardPreviewDismissed: true }
      : { isTablePreviewDismissed: true }),
    hasExplicitlyOpenedPreview: requireExplicitOpen
      ? false
      : gate.hasExplicitlyOpenedPreview,
  }
}

export function clearPreviewDismissals(
  gate: DocumentPreviewGate
): DocumentPreviewGate {
  return {
    ...gate,
    isCardPreviewDismissed: false,
    isTablePreviewDismissed: false,
  }
}

export function clearExplicitPreviewOpen(
  gate: DocumentPreviewGate
): DocumentPreviewGate {
  return { ...gate, hasExplicitlyOpenedPreview: false }
}
